// extracted by mini-css-extract-plugin
export default {"btn":"FeedbackOptions_btn__T-xZJ"};